export default "__VITE_ASSET__BNVyqq2j__"